// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions___jNWW","colMaxWidth":"Table_colMaxWidth__SJWAU"};